import { Button } from '@bambi/component-library/src/components/Button';
import { SimpleTooltip } from '@bambi/component-library/src/components/Tooltip/SimpleTooltip';

import { TilledLogo } from 'src/common/primitives/logos/TilledLogo';

import { useCanLaunchMerchantApplication } from '../helpers/useCanLaunchMerchantApplication';
import { useConnectMerchantAccount } from '../helpers/useConnectMerchantAccount';

export function ActiveTilledMerchantApplication() {
  const { loading, trigger: handleContinueMerchantApplication } =
    useConnectMerchantAccount();

  const canLaunchApplication = useCanLaunchMerchantApplication();

  return (
    <>
      <div className="flex flex-grow flex-row items-center gap-2">
        <TilledLogo />
        <div>
          Your merchant account is active, and you are ready to start accepting
          payments!
        </div>
      </div>
      <div>
        <SimpleTooltip
          trigger={
            <div className="flex">
              <Button
                dataTestId="tilled-connect-button"
                loading={loading}
                onClick={handleContinueMerchantApplication}
                disabled={!canLaunchApplication}
              >
                Open Tilled Console
              </Button>
            </div>
          }
          content={
            !canLaunchApplication
              ? 'Only Owners can perform this function'
              : null
          }
        />
      </div>
    </>
  );
}
